import {createFileRoute} from '@tanstack/react-router';

import {NewSitePage} from '@/modules/sites/pages/NewSitePage';

export const Route = createFileRoute('/_authenticated/sites/new')({
  component: NewSitePage,
});
